<template>
    <div>
        <van-overlay z-index="10000" :show="popShow" >
            <div class="wrapper" @click.stop  :style="{paddingTop:(height/2-50)+'px'} ">
                <van-loading type="spinner" size="100px" />
            </div>
        </van-overlay>
    </div>
</template>

<script>
    export default {
        name: "loading",

        data(){
            return{
                popShow:true,
                height:document.body.clientHeight
            }
        },
        watch:{
            popShow(){
                console.log(this.popShow,'popShow')
            }
        }
    }
</script>

<style scoped>
.wrapper{
    width: 100%;
    text-align: center;
}
.van-overlay{
    opacity: 0.4;
}
</style>
